import { UserRoleE } from "../../models/enums";

export const mapClientTypeToRole = (clientType: number) => {
    switch (clientType) {
        case 0: return UserRoleE.AdvertisingAgency;
        case 2: return UserRoleE.PostProduction;
        case 3: return UserRoleE.Broadcaster;
        case 5: return UserRoleE.DeliveryService;
        case 6: return UserRoleE.Production;
        // Media company (ClientTypeE["Media Company"] = 7). Explicit case is mandatory so a
        // media-company user is never silently elevated to GlobalAdmin by the default below.
        case 7: return UserRoleE.MediaCompany;
        default: return UserRoleE.GlobalAdmin;
    }
};